import Vue from 'vue'
import VForm from 'vuetify/lib/components/VForm/VForm'

const base = Vue.extend({ mixins: [VForm] })
export default base.extend({
    name: "my-form",
    methods:{
        my_validate(){
            var tmp = this.validate();
            setTimeout(() => {
                if($('.error--text').length > 0){
                    this.$vuetify.goTo($('.error--text')[0], {offset: 50});
                }
            },100)
            return tmp;
        }
    }
})
